import { webmafAction } from "../webmafActions";

export const device = {
  async getId() {
    return new Promise(resolve => {
      webmafAction("hwid", {}, data => {
        resolve(data.hwid);
      });
    });
  },

  async getModel() {
    return WM_devSettings.deviceName;
  },

  async getModelCode() {
    return "";
  },

  async getRealModel() {
    return "";
  },

  async getPlatform() {
    return "ps4";
  },

  async getServerVersion() {
    return "";
  },

  async getYear() {
    return "";
  },

  async supports4K() {
    return false;
  },

  async getFirmwareVersion() {
    return WM_devSettings.version;
  },

  getManufacturer() {
    return "sony";
  },

  getType() {
    return "Playstation";
  }
};
